import { render, staticRenderFns } from "./TrainingInProgressCatalogCard.vue?vue&type=template&id=22f48cd0&scoped=true"
import script from "./TrainingInProgressCatalogCard.vue?vue&type=script&lang=js"
export * from "./TrainingInProgressCatalogCard.vue?vue&type=script&lang=js"
import style0 from "./TrainingInProgressCatalogCard.vue?vue&type=style&index=0&id=22f48cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f48cd0",
  null
  
)

export default component.exports